import { create } from 'zustand';

export type TxType = 'income' | 'expense' | 'transfer';

export interface Transaction {
  id: string;
  familyId: string;
  walletId: string;
  toWalletId?: string;
  userId: string;
  type: TxType;
  amount: number; // grosze (integer)
  categoryId: string | null;
  note: string;
  date: Date;
  isRecurring: boolean;
  isPaused?: boolean;
  /** Jeśli ustawione — transakcja powstała z wpłaty na cel. Ukrywamy w drill-down. */
  goalId?: string;
  syncStatus?: 'synced' | 'pending';
}

interface TransactionsStore {
  transactions: Transaction[];
  loading: boolean;
  setTransactions: (transactions: Transaction[]) => void;
  addTransaction: (tx: Transaction) => void;
  updateTransaction: (id: string, patch: Partial<Transaction>) => void;
  removeTransaction: (id: string) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useTransactionsStore = create<TransactionsStore>((set) => ({
  transactions: [],
  loading: false,
  setTransactions: (transactions) => set({ transactions, loading: false }),
  addTransaction: (tx) => set((s) => ({ transactions: [tx, ...s.transactions] })),
  updateTransaction: (id, patch) =>
    set((s) => ({
      transactions: s.transactions.map((tx) => (tx.id === id ? { ...tx, ...patch } : tx)),
    })),
  removeTransaction: (id) =>
    set((s) => ({ transactions: s.transactions.filter((tx) => tx.id !== id) })),
  setLoading: (loading) => set({ loading }),
  reset: () => set({ transactions: [], loading: false }),
}));
